import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__edge } from '../_graph/DTO_GRAPH__edge';
import { ERROR_GRAPH__base } from './ERROR_GRAPH__base';

export class ERROR_GRAPH__edge extends ERROR_GRAPH__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ERROR_GRAPH_EDGE;

  /*
   * STATIC METHODS
   */
  static create(type: ENUM__error_type, edge: DTO_GRAPH__edge = DTO_GRAPH__edge.CREATE_STUB()) {
    let out = new ERROR_GRAPH__edge();

    out.type = type;
    out.edge = edge.clone();

    return out;
  }

  /*
   * FIELDS
   */

  edge: DTO_GRAPH__edge;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.edge = DTO_GRAPH__edge.CREATE_STUB();
  }

  override is_equals(other: ERROR_GRAPH__base): boolean {
    if (!super.is_equals(other)) return false;
    if (!(other instanceof ERROR_GRAPH__edge)) return false;

    return other.edge.is_equals(this.edge);
  }
}
